var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},_vm.$listeners),[_c('path',{attrs:{"fill":"#f0f0f0","d":"M0 0h512v512H0z"}}),_c('path',{attrs:{"fill":"#0052b4","d":"M0 0h170.663v512H0z"}}),_c('path',{attrs:{"fill":"#d80027","d":"M341.337 0H512v512H341.337z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }